"use client";
import Image from "next/image";

export default function ShareButton() {
  const handleShare = async () => {
    const currentUrl = window.location.href;

    if (navigator.share) {
      await navigator.share({
        title: document.title,
        text: "Check this out!",
        url: currentUrl,
      });
    } else {
      await navigator.clipboard.writeText(currentUrl);
    }
  };

  return (
    <div className="relative inline-block">
      <button
        type="button"
        onClick={handleShare}
        aria-label="Share"
        className="rounded-md p-2 transition"
      >
        <Image
          src="https://static-asset.tractorjunction.com/cj/pdp-icons/share-icon.svg"
          alt="Share"
          title="Share"
          width={24}
          height={24}
          className="h-[24px] w-[24px]"
        />
      </button>
    </div>
  );
}
